import { Link } from "react-router-dom";
import {useSiteSettingsContext} from "@/hooks/useSiteSettingsContext";

interface LogoProps {
  variant?: "light" | "dark";
  size?: "sm" | "md" | "lg";
}

const LOGO_URL =
  "https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/701ba01ffa472e24f05c5cced92a417f.png";

const sizeMap = {
  sm: { container: "h-9", img: "h-9 w-auto" },
  md: { container: "h-14 md:h-16", img: "h-14 w-auto md:h-16" },
  lg: { container: "h-20 md:h-24", img: "h-20 w-auto md:h-24" },
};

export default function Logo({ variant = "light", size = "md" }: LogoProps) {
  const s = sizeMap[size];
  const { settings } = useSiteSettingsContext();
  const name = (settings.siteName || "DersDinle").trim();

  return (
    <Link
      to="/"
      className="flex items-center shrink-0 group"
      aria-label={`${name} ana sayfa`}
    >
      <img
        src={LOGO_URL}
        alt={name}
        className={`${s.img} object-contain`}
      />
    </Link>
  );
}